


























































































import { Component, Vue, Prop, Provide, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import { IProperty } from "../../models/interfaces/property/property.model.interface";

import Loader from "@/components/Loader.vue";
import BlockBrandToolTip from "@/components/property/BlockBrandToolTip.vue";
import { IPropertyBlockBrand } from "@/models/interfaces/property/property-block-brand.model.interface";
import { PropertyBlockBrand } from "../../models/property/property-block-brand.model";

const ProductModule = namespace("productModule");
const PropertyManagementModule = namespace("propertyManagementModule");

@Component({
  components: {
    Loader,
    BlockBrandToolTip
  }
})
export default class PropertyBlockBrands extends Vue {
  get getProperty(): IProperty {
    return this.property;
  }

  get loadingStatus(): boolean {
    return this.loading || this.internalLoading;
  }
  @ProductModule.Action public retrieveProductCategories;
  @ProductModule.Getter public productCategories;

  @ProductModule.Action public retrieveCategoryBrands;
  @ProductModule.Getter public categoryBrands;

  @PropertyManagementModule.Action public addBlockedBrand;
  @PropertyManagementModule.Action public removeBlockedBrand;

  @Prop({ default: "Table" })
  public caption: string;

  @Prop({ default: false })
  public hover: boolean;

  @Prop({ default: false })
  public striped: boolean;

  @Prop({ default: true })
  public bordered: boolean;

  @Prop({ default: false })
  public small: boolean;

  @Prop({ default: false })
  public fixed: boolean;

  @Prop() public property: IProperty;

  @Prop() public loading: boolean;

  @Provide() public categoryOptions: any[] = [];

  @Provide() public brandOptions: any[] = [];

  @Provide()
  public selectedBlockedBrand: IPropertyBlockBrand = new PropertyBlockBrand();

  @Provide() public existingBlockedBrands: IPropertyBlockBrand[] = [];

  @Provide()
  public blockedBrandToRemove: IPropertyBlockBrand = new PropertyBlockBrand();

  @Provide()
  public columns = [
    {
      key: "productCategory.name",
      label: "Category"
    },
    {
      key: "brandName",
      label: "Brand"
    },
    {
      key: "selection",
      label: "Selection",
      formatter: (value, key, item) => {
        return item;
      }
    },
    {
      key: "actions",
      label: "Delete",
      formatter: (value, key, item) => {
        return item;
      }
    }
  ];

  private show: boolean = false;

  private internalLoading: boolean = false;

  @Watch("getProperty", { deep: true })
  public onPropertyUpdate() {
    this.updateCurrentBlockedBrands();
  }

  @Watch("selectedBlockedBrand.productCategoryId")
  public onSelectedCategoryUpdate() {
    this.updateBrands();
  }

  public showModal(blockedBrand: IPropertyBlockBrand) {
    this.blockedBrandToRemove = blockedBrand;
    this.show = true;
  }

  public hideModal() {
    this.show = false;
    this.blockedBrandToRemove = new PropertyBlockBrand();
  }

  public addItem() {
    if (
      this.selectedBlockedBrand.productCategoryId > 0 &&
      this.selectedBlockedBrand.brandId > 0 &&
      (this.selectedBlockedBrand.blockOnBrand === true ||
        this.selectedBlockedBrand.blockConquest === true)
    ) {
      const blockedBrand = this.generateSelectedBlockedBrand();
      this.addBlockedBrand(blockedBrand).then((result) => {
        this.updateBrandOptions();
        this.updateCurrentBlockedBrands();
      });
    }
  }

  public removeItem() {
    if (
      this.blockedBrandToRemove.productCategoryId > 0 &&
      this.blockedBrandToRemove.brandId > 0
    ) {
      this.removeBlockedBrand(this.blockedBrandToRemove).then((result) => {
        if (result) {
          this.hideModal();
          this.updateBrandOptions();
          this.updateCurrentBlockedBrands();
        }
      });
    }
  }

  public created() {
    this.loadCategories();
    this.updateCurrentBlockedBrands();
  }

  private loadCategories() {
    this.selectedBlockedBrand.productCategoryId = 0;
    this.retrieveProductCategories().then((result) => {
      if (result) {
        this.categoryOptions = this.productCategories.map((val) => ({
          value: val.productCategoryId,
          text: val.name
        }));
      }
    });
  }

  private updateBrands() {
    this.selectedBlockedBrand.brandId = 0;
    if (this.selectedBlockedBrand.productCategoryId < 1) {
      this.brandOptions = [];
    } else {
      this.retrieveCategoryBrands(
        this.selectedBlockedBrand.productCategoryId
      ).then((result) => {
        if (result) {
          this.updateBrandOptions();
        }
      });
    }
  }

  private updateCurrentBlockedBrands() {
    this.selectedBlockedBrand.brandId = 0;
    this.existingBlockedBrands = this.property.blockedBrands;
  }

  private updateBrandOptions() {
    const currentBrandIds = this.property.blockedBrands
      .filter((x) => x.productCategoryId === this.selectedBlockedBrand.productCategoryId)
      .map((x) => x.brandId);

    this.brandOptions = this.categoryBrands
      .filter((x) => !currentBrandIds.includes(x.brandId))
      .map((val) => ({
        value: val.brandId,
        text: val.brandName
      }));
  }

  private generateSelectedBlockedBrand(): IPropertyBlockBrand {
    const blockedBrand = new PropertyBlockBrand();
    blockedBrand.propertyId = this.getProperty.propertyId;
    blockedBrand.productCategoryId = this.selectedBlockedBrand.productCategoryId;
    blockedBrand.brandId = this.selectedBlockedBrand.brandId;
    blockedBrand.blockOnBrand = this.selectedBlockedBrand.blockOnBrand;
    blockedBrand.blockConquest = this.selectedBlockedBrand.blockConquest;

    blockedBrand.brandName = this.brandOptions.find(
      (x) => x.value === this.selectedBlockedBrand.brandId
    ).text;

    blockedBrand.productCategory = this.productCategories.find(
      (x) => x.productCategoryId === this.selectedBlockedBrand.productCategoryId
    );

    return blockedBrand;
  }
}
